import initForm, { initExitPopupForm } from 'landings/__assets__/scripts/components/form-handling'
import initButtonVisibility from 'landings/__assets__/scripts/components/scroll-button'
import { initWebWorker } from 'landings/__assets__/scripts/services/workerHandlerBiz'
import { initCountersObserver } from 'landings/__assets__/scripts/components/counters-animation'
import initExitPopup from 'landings/__assets__/scripts/components/exit-popup'
import initAnimation from 'landings/__assets__/scripts/components/intersection-observer'
import { initCurrencyLandingsAnimations } from 'landings/__assets__/scripts/components/currency-land-animations'
import cookieConsent from 'services/cookies-consent'

initForm(true)
initButtonVisibility()
cookieConsent.init()
initExitPopupForm()
initWebWorker()
initCountersObserver()
initExitPopup()
initAnimation()
initCurrencyLandingsAnimations()
